import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

import classes from './ConFanolly.module.scss';

import imgFLion from '../../../../assets/images/Fanolly LION.png';
import imgBT from '../../../../assets/images/BT.png';
import imgKT from '../../../../assets/images/KT.png';
import imgFanolly from '../../../../assets/images/Fanollywood_New_Logo.png';
import BigButton from '../../../UI/BigButton/BigButton';

const contents = [
  {
    img: imgFanolly,
    title: 'About the Fanolly Network',
    texts: [
      "A fast-growing media network for lovers of cinema, separated into 3 active networks; Bollyticket, Kollyticket and Fanolly pictures. The Indian cinema thrives from the love of its fans and their rave for their favourite movies and stars. Drawing from that, Fanolly got its name; Fans plus – Bollywood, Tollywood and Kollywood. That’s why the overall vision of the brand is to bring complete satisfaction to Indian cinema fans anywhere and everywhere.",
      
      "Fanolly network is the bedrock of all 3 (Bollyticket, Kollyticket and Fanolly pictures) brands. The maintenance, funding and general overseeing of the brands are taken care of here. Investors also form part of the Fanolly team; they are determined to stick with this brand to make it known and available to all Indian cinema lovers and fans throughout the world."
    ],
	  visitLink: 'https://www.fanolly.com',
    email: 'contact@fanolly.com'
  },
  {
    img: imgBT,
    title: 'What is Bollyticket?',
    texts: [
      "made explicitly for our vibrant Indian audience. Bollyticket brings you all the latest, hottest news about Bollywood celebrities anytime and anywhere. Made up of a team that is committed to gathering accurate information, the site is daily updated to bring our audience up to date information about their favourite entertainment industry."
    ],
	visitLink: 'https://www.bollyticket.com',
    email: 'contact@fanolly.com'
  },
  {
    img: imgKT,
    title: 'Introducing Kollyticket',
    texts: [
      "Kollyticket brings you all the hottest news from the Tamil cinema industry, Latest trailers, What movies are set to be released? Public reaction to celebrities latest news. Find it all at Kollyticket."
    ],
	visitLink: 'https://www.kollyticket.com',
    email: 'contact@fanolly.com'

  },
  {
    img: imgFLion,
    title: 'Introducing Fanolly Pictures',
    texts: [
      "For the best motion pictures, a group of experienced professionals came together to form a brand that creates top-notch unique quality films. From writing to scripting to producing, we pay close attention to the quality. The young, vibrant professional team at Fanolly has mastered the art of video production; we know exactly what it takes to bring visions to life. From framing to stage lighting, and even on-set direction, we offer diverse skillsets to get the exact results we want."
    ],
	visitLink: 'https://www.fanollywood.com',
    email: 'contact@fanolly.com'
  }
];

const images = contents.map(c => c.img);
const textContents = contents.map(c => c.texts);
const titles = contents.map(c => c.title);

const ConFanolly = ({ colors, end, className, style }) => {
  const [activeIndex, setActiveIndex] = useState(0);


  const rootClass = [classes.ConFanolly];
  if (className) rootClass.push(className);


  return (
    <div className={rootClass.join(' ')} style={style ? style:{}}>
      <div className={classes.Left}>
        <div className={classes.Images}>
          {end && images.map((img, i) => {
            const classNames = [classes.ImageContainer];
            const styles = {};
            styles.padding = '2rem';
            if (i === 3) {
              styles.backgroundColor = '#303030';
              styles.padding = '2.2rem';
            }
            else if (i === 0) styles.backgroundColor = '#000000';
            else if (i === 1) styles.backgroundColor = '#ED174F';
            else if (i === 2) styles.backgroundColor = '#FFF200';
            if (i === activeIndex) classNames.push(classes.Active);
            
            return (
              <motion.div key={i} className={classNames.join(' ')} style={styles} onClick={()=> setActiveIndex(i)}
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{ delay: 0.05 * i }}
              >
                <img src={img} alt="IMG" className={classes.Image} />
              </motion.div>
            );
          })}
        </div>
      </div>

      {end && <motion.div className={classes.Right} style={{ color: colors[0] }}
        initial={{ x: -100, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        exit={{ x: 100, opacity: 0 }}
      >
        <div className={classes.TextContents}>
          <h4 className={classes.Title}>{titles[activeIndex]}</h4>

          <div className={classes.Details}>
            {textContents[activeIndex].map((text, i) => {
              return (
                <p key={i} className={classes.Text}>{text}</p>
              );
            })}
          </div>
        </div>

        <div className={classes.Buttons}>
         <a href={contents[activeIndex].visitLink} target="_blank" className={classes.Link}>
            <BigButton style={{ color: colors[0] }} className={classes.Btn} grad>
              Visit Website
            </BigButton>
          </a>

          <p className={classes.EmailText}>{contents[activeIndex].email}</p>
        </div>
      </motion.div>}
    </div>
  );
}

export default ConFanolly;